import { makeStyles } from '@material-ui/core'

export const useOrderStyles = makeStyles(theme => ({
  productsViewContainer: {
    display: 'flex'
  },
  content: {
    flexGrow: 1,
    marginTop: -12
  },
  contentSidebar: {
    marginLeft: 200
  },
  productNavAndViewContainer: {
    height: 'calc(100% - 40px)'
  },
  divider: {
    width: '100%',
    position: 'absolute',
    zIndex: 999
  },
  sidebarToggleBtnWrapper: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  sidebarToggleBtn: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer'
  }
}))
